import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Button, Icon, Divider } from 'semantic-ui-react';

import { fishermanBackendRedirect } from 'libs/auth';

import {
  AUTH_METHODS,
  BUTTON_LABELS,
  BUTTON_SUBTITLES,
  BUTTON_ICONS,
} from './LoginRedirectOptions.constants';

import './LoginRedirectOptions.scss';

const propTypes = {
  hidePasswordOption: PropTypes.bool,
  hideEmailOption: PropTypes.bool,
  hidePhoneOption: PropTypes.bool,
  hideGoogleOption: PropTypes.bool,
};

const defaultProps = {
  hidePasswordOption: false,
  hideEmailOption: false,
  hidePhoneOption: false,
  hideGoogleOption: false,
};

function LoginRedirectOptions({
  hidePasswordOption,
  hideEmailOption,
  hidePhoneOption,
  hideGoogleOption,
}) {
  const [loading, setLoading] = useState(false);
  function onAuthMethodClick(method) {
    setLoading(true);
    const pathTemplate = '/auth/login/{method}';
    const path = pathTemplate.replace('{method}', method);
    fishermanBackendRedirect(path);

    setTimeout(() => {
      setLoading(false);
    }, 3000);
  }

  const primaryOptions = [
    {
      method: AUTH_METHODS.PASSWORD,
      hidden: hidePasswordOption,
    },
    {
      method: AUTH_METHODS.EMAIL,
      hidden: hideEmailOption,
    },
    {
      method: AUTH_METHODS.PHONE,
      hidden: hidePhoneOption,
    },
  ].filter(({ hidden }) => !hidden);

  const showGoogleOption = !hideGoogleOption;
  const showDivider = primaryOptions.length > 0 && showGoogleOption;

  return (
    <div className="login-redirect-options">
      {primaryOptions.map(({ method }) => {
        const subtitle = BUTTON_SUBTITLES[method];
        return (
          <Button
            key={method}
            fluid
            className={`login-option-card ${method}`}
            onClick={() => onAuthMethodClick(method)}
            disabled={loading}
          >
            <div className="icon">
              <Icon name={BUTTON_ICONS[method]} />
            </div>
            <div className="content">
              <div className="title">{BUTTON_LABELS[method]}</div>
              {subtitle && <div className="subtitle">{subtitle}</div>}
            </div>
          </Button>
        );
      })}

      {showDivider && <Divider horizontal>OR</Divider>}

      {showGoogleOption && (
        <Button
          fluid
          className="google-button"
          icon={BUTTON_ICONS[AUTH_METHODS.GOOGLE]}
          content={BUTTON_LABELS[AUTH_METHODS.GOOGLE]}
          onClick={() => onAuthMethodClick(AUTH_METHODS.GOOGLE)}
          disabled={loading}
        />
      )}
    </div>
  );
}

LoginRedirectOptions.propTypes = propTypes;
LoginRedirectOptions.defaultProps = defaultProps;

export default LoginRedirectOptions;
